module.exports = __webpack_public_path__ + "img/yccText.4f7ab754.png";